module.exports = "data:image/gif;base64,R0lGODlhtAABAIABAFilxgAAACH5BAEAAAEALAAAAAC0AAEAAAIWjIGJxqzazlux2ovlzND2rAHgSIZWAQA7"


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/BlueOpal/slider-v.gif
// module id = ../../../../../external_css/kendo-ui/BlueOpal/slider-v.gif
// module chunks = styles